// PortalTooltip.js (can also paste directly above LeftRail if you want)
import React, { useRef, useState } from "react";
import { createPortal } from "react-dom";

// Helper for portal root (re-uses or creates #portal-tooltips)
function getPortalRoot() {
  let el = document.getElementById("portal-tooltips");
  if (!el) {
    el = document.createElement("div");
    el.id = "portal-tooltips";
    document.body.appendChild(el);
  }
  return el;
}

export function PortalTooltip({ content, children }) {
  const [visible, setVisible] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0 });
  const btnRef = useRef();

  function showTooltip() {
    if (!btnRef.current) return;
    const rect = btnRef.current.getBoundingClientRect();
    setPos({
      top: rect.top + rect.height / 2,
      left: rect.right + 10, // 10px right of the button
    });
    setVisible(true);
  }
  function hideTooltip() {
    setVisible(false);
  }

  // Wrap child in a span so we can attach ref & handlers
  const trigger = React.cloneElement(children, {
    ref: btnRef,
    onMouseEnter: (e) => {
      showTooltip();
      if (children.props.onMouseEnter) children.props.onMouseEnter(e);
    },
    onMouseLeave: (e) => {
      hideTooltip();
      if (children.props.onMouseLeave) children.props.onMouseLeave(e);
    },
    onFocus: (e) => {
      showTooltip();
      if (children.props.onFocus) children.props.onFocus(e);
    },
    onBlur: (e) => {
      hideTooltip();
      if (children.props.onBlur) children.props.onBlur(e);
    },
  });

  return (
    <>
      {trigger}
      {visible &&
        createPortal(
          <div
            style={{
              position: "fixed",
              top: pos.top,
              left: pos.left,
              transform: "translateY(-50%)",
              zIndex: 9999,
              pointerEvents: "none",
            }}
            className="px-2 py-1 rounded bg-slate-800 text-white text-xs shadow-lg transition-all animate-fade-in"
          >
            {content}
          </div>,
          getPortalRoot()
        )}
    </>
  );
}
